import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import endPoint from "../EndPoint/endpoint";

export const GetBanner = createAsyncThunk(
  "getBannerData/GetBanner",
  async (_, thunkAPI) => {
    try {
      const response = await axios.get(endPoint.GetBannerApi);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

const GetBannerSlice = createSlice({
  name: "GetBanners",
  initialState: {
    GetBanners: [],
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GetBanner.fulfilled, (state, action) => {
        state.GetBanners = action.payload;
      })
      .addCase(GetBanner.rejected, (state, action) => {
        state.error = action.payload;
      });
  },
});

export default GetBannerSlice.reducer;
